export default {
  getData(state) {
    return state.data;
  },

};
